import { GetStaticProps } from 'next';
import { getNavigation, getPartners, NavigationProps } from '@amf/shared/utils/navigation';
import { getLanguageLocale } from '@amf/shared/utils/languages';
import React from 'react';
import { useTranslate } from '@tolgee/react';
import AdvancedSearch from '@amf/shared/components/search/AdvancedSearch';

import Layout from 'components/layout/Layout';
import Meta from 'components/Meta';
import { AppLinks } from 'utils/links';

type Props = {} & NavigationProps;

function SearchPage({ navigation, partners }: Props) {
  const { t } = useTranslate();
  return (
    <Layout navigation={navigation} partners={partners}>
      <Meta title={t('search.title')} />
      <AdvancedSearch
        prefixes={{
          news: AppLinks.newsList,
          player: AppLinks.player,
          league: AppLinks.statsLeague,
          club: AppLinks.club,
          ground: AppLinks.ground,
          team: AppLinks.team,
        }}
      />
    </Layout>
  );
}

export default SearchPage;

export const getStaticProps: GetStaticProps<Props> = async ({ locale }) => {
  return {
    props: {
      navigation: await getNavigation(getLanguageLocale(locale!)),
      partners: await getPartners(),
    },
    revalidate: 10,
  };
};
